import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterRangeSearchValueObject} from './FilterRangeSearchValueObject.js'

export class FilterLuggageCapacitySearchValueObject extends ValueObject {
  #luggageCapacity

  constructor({luggageCapacity}) {
    super()
    this.#luggageCapacity = luggageCapacity
  }

  static create({luggageCapacity}) {
    return new FilterLuggageCapacitySearchValueObject({
      luggageCapacity: FilterRangeSearchValueObject.create(luggageCapacity)
    })
  }

  static createWithDefaultValue({config, luggageCapacity}) {
    const {DEFAULT_LUGGAGE_CAPACITY_SEARCH} = config.get('searchFilters')

    return new FilterLuggageCapacitySearchValueObject({
      luggageCapacity: FilterRangeSearchValueObject.create({
        from: luggageCapacity?.from || DEFAULT_LUGGAGE_CAPACITY_SEARCH.from,
        to: luggageCapacity?.to || DEFAULT_LUGGAGE_CAPACITY_SEARCH.to
      })
    })
  }

  static createQueryParams({config, luggageCapacity}) {
    const {luggageCapacityTypes} = config.get('search')
    const {FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    // Normalize: backend may omit `from` when open-ended (e.g. {to: 199} instead of {from: null, to: 199})
    const normalized = {from: luggageCapacity?.from ?? null, to: luggageCapacity?.to ?? null}

    // Legacy code: Custom logic to find the selected luggage capacity
    const selectedLuggageCapacity = luggageCapacityTypes?.find(
      type => JSON.stringify(type.value) === JSON.stringify(normalized)
    )

    return new FilterLuggageCapacitySearchValueObject({
      luggageCapacity: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.LUGGAGE_CAPACITY],
        value: selectedLuggageCapacity?.id || null
      })
    })
  }

  get isEmpty() {
    return this.#luggageCapacity.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#luggageCapacity.queryParam})
    }
  }

  get value() {
    return this.#luggageCapacity.value
  }

  toJSON() {
    return {
      luggageCapacity: this.#luggageCapacity.toJSON()
    }
  }
}
